import { useMutation, useQuery } from "@tanstack/react-query";
import apiClient from "./apiClient";
import { ICarWashReqBody, ICancelCarWashReqBody } from "src/types/car-wash";

export const useCreateCarWashRequestMutation = () =>
  useMutation<any, { error: any }, ICarWashReqBody>({
    mutationFn: async (data) => {
      return apiClient.post(`/carWashRequestFunctionV3/createCarWashRequest`, data);
    },
  });

export const useCancelCarWashRequestMutation = () =>
  useMutation<void, any, ICancelCarWashReqBody>({
    mutationFn: async (data) => {
      return apiClient.post(
        `/carWashRequestFunctionV3/cancelCarWashRequest`,
        data,
      );
    },
  });

export const useGetLocationCarWashServices = (locationId: string) =>
  useQuery<any, any, any>({
    queryKey: ["get-location-car-wash-services-by-id"],
    queryFn: async () => {
      return apiClient.get(
        `/carWashRequestFunctionV3/getCarWashServices?locationId=${locationId}`,
      );
    },
    enabled: !!locationId,
  });
